import React, { useMemo } from 'react';
import { Package } from 'lucide-react';
import { AdminStocksSkeleton } from './components/AdminStocksSkeleton';
import { AdminStocksStats } from './components/AdminStocksStats';
import { AdminStocksTable } from './components/AdminStocksTable';
import { useAdminStocks } from './hooks/useAdminStocks';
import {
  getProviderOptions,
  getServiceDeskOptions,
  getStocksStats,
} from './utils';

const AdminStocks = () => {
  const { stocks, loading, error } = useAdminStocks();
  const serviceDeskOptions = useMemo(() => getServiceDeskOptions(stocks), [stocks]);
  const providerOptions = useMemo(() => getProviderOptions(stocks), [stocks]);
  const stats = useMemo(() => getStocksStats(stocks), [stocks]);

  if (loading && stocks.length === 0) {
    return <AdminStocksSkeleton />;
  }

  if (error) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 p-4 text-red-700">
        <h3 className="font-bold">Une erreur est survenue</h3>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto space-y-6 px-4 py-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="flex items-center gap-2 text-3xl font-bold text-gray-900">
            <Package className="h-8 w-8" />
            Stocks
          </h1>
          <p className="mt-1 text-gray-500">
            Visualisez les éléments avec stock remonté depuis les providers configurés
          </p>
        </div>
      </div>

      <AdminStocksStats stats={stats} />
      <AdminStocksTable
        stocks={stocks}
        serviceDeskOptions={serviceDeskOptions}
        providerOptions={providerOptions}
      />
    </div>
  );
};

export default AdminStocks;
